module.exports = __webpack_public_path__ + "static/media/sv1.09d95c74.png";